import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Image from "../components/image"

class DemoCarousel extends Component {
    render() {
        return (
            <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true}>
                
                <div>
                <Image alt="Gatsby in Space 1" filename="baby.jpg" />
                    <p className="legend">Lille Martine collage</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1420.jpeg" />
                    <p className="legend">Lille Martine</p>
                </div>
     
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1422.jpeg" />
                    <p className="legend">Lille Martine med pappa</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1425.jpeg" />
                    <p className="legend">Hipp hurra med søster</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1426.jpeg" />
                    <p className="legend">#raskebriller #olanordmannpåtur #visitnorway #crosscountryskiing #utno #oslove</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1427.jpeg" />
                    <p className="legend">Takk for nå Hemsedal! Team Cruisin <span role="img" aria-label="ski"> ’🥈⛷</span>  #seeyounextyear #hemsedalupndown #racing #skiracing #skiing #2ndplace #kvikklunsjtur</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1428.jpeg" />
                    <p className="legend">#hochkönig #interbancario #skimeeting #mariaalm #racetime #skiing #weloveskiing #alpenland #giantslalom</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1429.jpeg" />
                    <p className="legend">#andalo #interbancario #ib2016 #alps #italy #skiing #2ndplace</p>
                </div>

                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1431.jpeg" />
                    <p className="legend">#hemsedalupndown #racing #downhill #teamcrusin</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1474.jpeg" />
                    <p className="legend">Gratulerer med dagen!</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1482.JPG" />
                    <p className="legend">DNB @ work</p>
                </div>
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1483.jpg" />
                    <p className="legend">#hochkönig #winterwonderland #interbancario #amazing #mariaalm #skiing #alpenland</p>
                </div> 
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1484.jpg" />
                    <p className="legend">#sanfrancisco #fairmont #CA</p>
                </div> 
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1485.jpg" />
                    <p className="legend">#stmoritz #skiing #alps #giantslalom</p>
                </div> 
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1486.jpg" />
                    <p className="legend">Hvor blir det av snøen? #tbt #snow #skiing #savn #GS #downhill #fun #mountain #alpine #focus #fast #powder #shred #sun #love</p>
                </div> 
                
                <div>
                <Image alt="Gatsby in Space 2" filename="IMG_1487.jpg" />
                    <p className="legend">#touristing #edinburgh #thatviewtho #greengrassforthewin</p>
                </div>
            </Carousel>
        );
    }
}
 

export default DemoCarousel;